export default __webpack_public_path__ + "static/media/wi-day-snow-wind.d2f50978.svg";